import { render, staticRenderFns } from "./veHqCangku.vue?vue&type=template&id=f2bd4678&scoped=true"
import script from "./veHqCangku.vue?vue&type=script&lang=js"
export * from "./veHqCangku.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2bd4678",
  null
  
)

export default component.exports